"use strict";
/**
 * @author by Gor.Hakobyan on 13-May-19.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Measure;
(function (Measure) {
    Measure["ACTUAL"] = "Actual";
    Measure["BASELINE"] = "Baseline";
    Measure["TARGET"] = "Target";
    Measure["ACHIEVEMENT_AGAINST_OVERALL_WORK"] = "Achievement_Against_Overall_Work";
    Measure["ACHIEVEMENT_GROWTH_IN_PERCENT"] = "Achievement_Growth_In_Percent";
    Measure["ACHIEVEMENT_GROWTH"] = "Achievement_Growth";
    Measure["ACHIEVEMENT"] = "Achievement";
    Measure["CUMULATIVE_ACHIEVEMENT_GROWTH_IN_PERCENT"] = "Cumulative_Achievement_Growth_In_Percent";
    Measure["CUMULATIVE_ACHIEVEMENT_GROWTH"] = "Cumulative_Achievement_Growth";
    Measure["CUMULATIVE_ACHIEVEMENT"] = "Cumulative_Achievement";
    Measure["GROWTH_AGAINST_BASELINE"] = "Growth_Against_Baseline";
    Measure["GROWTH_IN_PERCENT"] = "Growth_In_Percent";
    Measure["GROWTH"] = "Growth";
    Measure["OVERALL_ACHIEVEMENT"] = "Overall_Achievement";
    Measure["PROGRESS"] = "Progress";
    Measure["REMAINING_WORK_IN_PERCENT"] = "Remaining_Work_In_Percent";
    Measure["REMAINING_WORK"] = "Remaining_Work";
    Measure["ACHIEVEMENT_LOP_IN_PERCENT"] = "Achievement_Lop_In_Percent";
    Measure["CUMULATIVE_TARGET"] = "Cumulative_Target";
    Measure["CUMULATIVE_ACTUAL"] = "Cumulative_Actual";
    Measure["OLD_ACHIEVEMENT"] = "Old_Achievement";
    Measure["BACKLOG"] = "Backlog";
    Measure["PERCENT_RP_ACHIEVED"] = "Percent_Rp_Achieved";
    Measure["CUMULATIVE_AGAINST_LOP_ACHIEVEMENT"] = "Cumulative_Against_Lop_Achievement";
})(Measure = exports.Measure || (exports.Measure = {}));
//# sourceMappingURL=measure.enum.js.map